const preferences = {
  preferenceSettings: {
    nameAlreadyExist: 'Repeated name!',
    nameIsEmpty: 'Name is empty!',
    notificationPreference: 'Select the sites and corresponding notification preference settings',
    option1: 'I want to receive Enphase recommended notifications for all sites',
    option2: 'I want to customise my notifications',
    pageHeader: 'Preferences',
    title: 'Select an option for Notifications',
    saveDialogHeader: 'Save Changes?',
    saveConfirmText: 'Do you want to save changes you have made?',
    cancelButton: 'Discard',
    saveButton: 'Save',
    defaultDeselectWarning: 'Note: You cannot remove sites from Default Preference Set',
    displayPreferences: 'Display Preferences',
    ownSites: 'Own Sites',
    otherSites: 'Other sites',
    emptySites: 'No sites available!',
    emptyPreferenceSet: 'No Preferences!',
    preference: 'Preference',
    actions: 'Actions',
    settingsInfo: 'These settings are applicable for Ensemble sites only',
    selectType: 'Preference Sets',
    selectSite: 'Site selection',
    selectSettings: 'Notification Preference Settings',
    addText: 'Add',
    deleteAlertHeader: 'Confirm Deletion',
    deleteAlertDescription: 'Are you sure you want to permanently remove this preference?',
    deleteAlertCancel: 'Cancel',
    deleteAlertConfirm: 'Ok',
    siteEditWarning:
      'By default, all owned sites and other sites are set to "Default Preference – owned" and "Default Preference – Others" as their Notification Preference respectively.',
    defaultOwnInfo: 'All owned sites are set to "Default Preference – owned"',
    defaultOtherInfo: 'All other sites are set to "Default Preference – others"',
    defaultInfo: 'All sites are set to "Default Preference"',
    createNew: 'Add new preference',
    siteEditWarningMinimal: 'By default, sites are set to "Default Preference" as their Notification Preference',
    selectAll: 'Select All',
    generalNotification: 'General Notifications',
    switchToNewPreferencePage: 'SWITCH TO NEW PREFERENCE PAGE'
  },
  preferences: {
    pageHeader: 'Preferences',
    title: 'Preferences Settings',
    notificationPreference: 'Notification Preferences',
    activationNotification: 'Send me activation notifications.',
    monthlySummary: 'Send me monthly system performance summaries.',
    newsletters: 'Send me newsletters, promotions, and surveys regarding Enphase products or services.',
    newLeadsNotification: 'Notify me for new leads and their status changes',
    alertEmail: 'ALERT EMAIL PREFERENCES',
    deviceEventsEmail: 'Email me about device-level events (select impact level below):',
    exceptionsAlertEmail: 'You can specify exceptions to your alert email preference by system.',
    alertPreferences: 'View alert preferences by system',
    saveNotificationPreferences: 'SAVE NOTIFICATION PREFERENCES',
    displayPreferences: 'Display Preferences',
    displayUnits: 'Display Units',
    metric: 'Metric',
    imperial: 'Imperial',
    saveDisplayPreferences: 'SAVE DISPLAY PREFERENCES',
    systemAlert: 'System alert preference: ',
    saveChanges: 'Save Changes',
    label: 'Email me about device-level events (select impact level below):',
    alertEmailPreference: 'Alert Email Preference',
    systems: 'Systems'
  }
};

export default preferences;
